import { useState, useEffect } from 'react';
import { SubcategoriesService } from '../services/subcategories.service';

/**
 * Contains logic for rendering subcategories section and handling its changes
 */
export const useSubcategoriesLogic = ({
    vertical,
    defaultSubCategoryId,
    changedVerticalOnClick,
}) => {
    const [currentSubcategoryId, setCurrentSubcategoryId] = useState(defaultSubCategoryId);

    // track CasinoVertical component re-renders with new categories
    // apply new default subcategory in state (will not be done automatically by react)
    useEffect(() => {
        setCurrentSubcategoryId(defaultSubCategoryId);
    }, [changedVerticalOnClick, defaultSubCategoryId]);

    // on page reload - select last visited subcategory
    useEffect(() => {
        const savedSubcategoryId = SubcategoriesService.getSelectedSubcategory(vertical.id);

        if (savedSubcategoryId) {
            setCurrentSubcategoryId(parseInt(savedSubcategoryId, 10));
        }
    }, []);

    // on any re-render - apply deeplink change
    useEffect(() => {
        const deeplinkSubcategoryId = SubcategoriesService.getDeeplinkSubcategory(vertical.id);
        if (deeplinkSubcategoryId) {
            SubcategoriesService.clearDeeplinkSubcategory(vertical.id);
            setCurrentSubcategoryId(parseInt(deeplinkSubcategoryId, 10));

            // scrollIntoView will not work in case other scroll is in progress, so it should be delayed
            // for Jackpots we scroll page to subcategories first and then showing selected Jackpot category
            setTimeout(() => {
                const subcategoryElement = document.getElementById(`asg-subcategories__item--${deeplinkSubcategoryId}`);
                if (subcategoryElement) {
                    subcategoryElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'start',
                    });
                }
            }, 1000);
        }
    });

    // save current subcategory in LS
    useEffect(() => {
        SubcategoriesService.saveSelectedSubcategory(vertical.id, currentSubcategoryId);
    }, [currentSubcategoryId]);

    const handleSubcategoryChange = (subcategoryId) => {
        SubcategoriesService.scrollIntoView();
        setCurrentSubcategoryId(subcategoryId);
    };

    const currentCategoryFiltered = vertical?.children?.filter(({ id }) => (id === currentSubcategoryId));

    // render first subcategory if currentSubcategoryId not found in children
    // e.g. outdated ID in local storage
    const currentSubcategory = currentCategoryFiltered?.length === 0
        ? vertical?.children?.[0] : currentCategoryFiltered?.[0];

    return {
        handleSubcategoryChange,
        currentSubcategory,
        currentSubcategoryId,
    };
};
